import React from 'react';
import ResponsiveCarousel from 'components/ResponsiveCarousel';
import SmartContentCard from '../../shared/smartContentCard';
import { jsx as _jsx } from "react/jsx-runtime";
export var CollectionCarousel = function CollectionCarousel(_ref) {
  var large = _ref.large,
    items = _ref.items,
    isShared = _ref.isShared,
    qaIdContext = _ref.qaIdContext;
  return /*#__PURE__*/_jsx(ResponsiveCarousel, {
    items: items,
    breakpoints: ['base', 'xs', 's', 'm'],
    itemsPerSlide: large ? [1, 2, 2, 2] : [1, 2, 3, 3],
    maxItems: large ? [5, 6, 6, 6] : [5, 6, 9, 9],
    gutterWidth: ['xs', 's', 'm', 'l'],
    lookAhead: ['m', 'm', undefined, undefined],
    verticalSpacing: "xxxs",
    "aria-labelledby": qaIdContext,
    children: function children(collection, isCurrentSlide) {
      return /*#__PURE__*/_jsx(SmartContentCard, {
        content: collection,
        thumbnailDimensions: large ? 'w_561,h_150' : undefined,
        isShared: isShared,
        isFocusDisabled: !isCurrentSlide
      });
    }
  });
};
export default CollectionCarousel;